
import Vue from "vue"
import { mapState } from "vuex"

export default Vue.extend({
  middleware: "auth",
  auth: "guest",

  layoutSettings: {
    noBanner: true,
    titleToken: "pages.auth.registration.title",
  },

  // validate ({ store }) {
  //   return Boolean(store.state.user.registrationModel)
  // },

  data: () => ({
    isMounted: false,
  }),

  computed: {
    ...mapState("app", ["event"]),
    bannerSrc (): string {
      return this.event?.theme?.registrationBanner?.url || ""
    },
    description (): string {
      return this.$fmt.localize(this.event?.description) || ""
    },

    title (): string {
      const { status } = this.$route.query

      switch (status) {
        case "speaker":
          return this.$t("pages.auth.registration.speaker") as string

        case "organizer":
          return this.$t("pages.auth.registration.organizer") as string

        default:
          return this.$t("pages.auth.registration.participant") as string
      }
    },
  },

  mounted () {
    this.isMounted = true
  },
})
